import { render, staticRenderFns } from "./UserRequest.vue?vue&type=template&id=6c01b080&scoped=true&"
import script from "./UserRequest.vue?vue&type=script&lang=js&"
export * from "./UserRequest.vue?vue&type=script&lang=js&"
import style0 from "./UserRequest.vue?vue&type=style&index=0&id=6c01b080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c01b080",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardActions,VCardTitle,VProgressLinear})
